/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import { Tag } from 'antd'

import TimeLineModal from './TimeLineModal'

const OrderStatus = ({
  orderStatus, orderStatusDesc, orderId, click,
}) => {
  const [visible, setVisible] = useState(false)
  const color = () => {
    if (orderStatus === undefined) return 'gray'
    if (orderStatus === null) return 'gray'
    if (orderStatus === 'DRF') return 'gray'
    if (orderStatus === 'REJ') return '#F5222D'
    if (orderStatus === 'POCC') return '#F5222D'
    if (orderStatus === 'OBS') return '#FF6E40'
    if (orderStatus === 'ERR') return '#FFC53D'
    if (orderStatus === 'SOC') return '#1E88E5'
    if (orderStatus === 'ODI') return '#E53935'
    if (orderStatus === 'ODS') return '#7C4DFF'
    if (orderStatus === 'ODV') return '#512DA8'
    if (orderStatus === 'SOA') return '#52C41A'
    if (orderStatus === 'POC') return '#096DD9'
    if (orderStatus === 'POR') return '#CF1322'
    if (orderStatus === 'POA') return '#7CB305'
    if (orderStatus === 'PRD') return '#795548'
    if (orderStatus === 'PRC') return '#669966'
  }
  return (

    <>
      <TimeLineModal
        orderId={orderId}
        visible={visible}
        onCancel={() => { setVisible(!visible) }}
      />

      <Tag
        onClick={() => click && setVisible(!visible)}
        color={color()}
      >{orderStatusDesc}
      </Tag>
    </>

  )
}
export default OrderStatus
